import React from 'react';
import './PreviousClientBox.css'

const PreviousClientBox = ({data}) => {
  const {title, companies} = data;
  return (
    <div className='col span-1-of-5 previous-client-box'>
      <h3>{title}</h3>
      <ul>
        {companies.map((company, index) => <li key={index}>{company}</li>)}
      </ul>
    </div>
  )
}

export default PreviousClientBox;



// WEBPACK FOOTER //
// ./src/components/PreviousClientBox.js